module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[46]533.85aa045.woff2";